export enum RunningStatus {
  stop = 'stop',
  queueing = 'queueing',
  running = 'running',
  success = 'success',
  error = 'error',
}
